import { useTranslation } from 'react-i18next';
import { NavItem } from './components/nav-item/nav-item';
import './navigation.scss';
import BookrLogo from '../../../../assets/images/bookr-logo-s.png';

export const Navigation: React.FC = () => {
	const { t } = useTranslation();

	return (
		<nav className='header-navbar'>
			<div className='bookr-logo'>
				<img src={BookrLogo} alt='logo' />
			</div>

			<NavItem displayName={t('backEnd.navigation.appointment')} icon='calendar' url='bookr' />
			<NavItem displayName={t('backEnd.openingTime.headline')} icon='time' url='bookr-opening-time' />
			<NavItem displayName={t('common.customer')} icon='buddypress' url='bookr-customers' />
			<NavItem displayName={t('backEnd.navigation.shortcode')} icon='shortcode' url='bookr-shortcodes' />
			<NavItem displayName={t('backEnd.navigation.settings')} icon='cog' url='bookr-settings' />
		</nav>
	);
};
